/**
 * 소개·칩 저장이 서버에서 409 AUTOSAVE_CONFLICT 로 끝났을 때 다시 보내는 규칙(2026-10-11 Codex 후속).
 * 서버는 요청 순서를 모른다 — 다른 저장이 먼저 끝나 입력·단계가 바뀌면, 더 새 요청도 409 를 받을 수 있다.
 * 그래서 화면이 **아직 이 요청이 최신일 때만** 잠깐 쉬고 다시 보낸다. 더 새 요청이 생겼으면 그쪽에 맡긴다.
 */
export const AUTOSAVE_CONFLICT = "AUTOSAVE_CONFLICT";

export function isAutosaveConflict(error: unknown): boolean {
  return typeof error === "object" && error !== null && (error as { code?: unknown }).code === AUTOSAVE_CONFLICT;
}

/** `run` 을 부르고, 충돌이면 `stillLatest()` 가 참인 동안 최대 `retries` 번 다시 부른다. 최신이 아니게 되면 `undefined`. */
export async function retryOnAutosaveConflict<T>(
  run: () => Promise<T>,
  stillLatest: () => boolean,
  { retries = 2, delayMs = 500, wait = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms)) } = {},
): Promise<T | undefined> {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await run();
    } catch (error) {
      if (!isAutosaveConflict(error) || attempt >= retries || !stillLatest()) throw error;
      await wait(delayMs);
      if (!stillLatest()) return undefined;
    }
  }
}
